import Header from "../../components/header/Header";
import classes from "./wrapper.module.css";
import Footer from "../../components/footer/Footer"
import {useEffect, useState} from 'react';
import {
    Outlet, useNavigate
} from "react-router-dom";
import Modals from "../../components/modal/Modal";
import Loading from "../../components/loading/Loading";
import LoginForm from "../../components/Auth/LoginForm";
import logo from "../../images/usericon.png";
import {processLogin, processLogout} from "../../services/authService";
import {getProfile} from "../../clients/AuthApiClient";
import {AuthContext} from "../../context/AuthContext";

const Wrapper = (props) => {

    const [isModal, setModalTarget] = useState(false);
    const [isLoginModal, setLoginModal] = useState(false);
    const [isUserAuth, setUserAuth] = useState(false);
    const [isUserAdmin, setUserAdmin] = useState(false);
    const [avatar, setAvatar] = useState('');
    const [profile, setProfile] = useState({});
    const navigate = useNavigate();

    async function loadAuthUser() {
        const profileData = await getProfile();
        if (profileData && profileData.data) {
            const avatar = profileData.data.avatar_url;
            if (avatar) {
                setAvatar(avatar);
            } else {
                setAvatar(logo)
            }
            if (profileData && profileData.data) {
                setUserAdmin(profileData.data.role === 'ROLE_ADMIN');
            }
            setProfile(profileData.data);
            setUserAuth(true)
            setLoginModal(false)
        }
    }

    async function handleLogin(login, password) {
        const process = await processLogin(login, password);
        if (process) {
            await loadAuthUser();
        }
    }

    async function handleLogout() {
        await processLogout()
        setUserAdmin(false);
        setProfile({});
        setUserAuth(false)
        navigate("/")
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                await loadAuthUser();
            } catch (err) {
                setUserAdmin(false);
                setProfile({});
                setUserAuth(false)
            }
        }
        fetchData();
    }, []);

    return (
        <AuthContext.Provider
            value={{
                loadAuthUser,
                isUserAuth,
                isUserAdmin,
                profile,
                setProfile,
                avatar,
                setAvatar
            }}
        >
            <div className={classes.wrapper}>
                <Header
                    setModalTarget={setModalTarget}
                    setLoginModal={setLoginModal}
                    isUserAuth={isUserAuth}
                    avatar={avatar}
                    username={profile.username}
                    handleLogout={handleLogout}
                />
                <div className={classes.content}>
                    <Outlet/>
                </div>
                <Footer/>
                {isModal && (
                    <Modals isModal={isModal} setModalTarget={setModalTarget}/>
                )}

                {isLoginModal && (
                    <LoginForm isLoginModal={isLoginModal} setLoginModal={setLoginModal}
                               handleLogin={handleLogin}/>
                )}
                <Loading/>
            </div>
        </AuthContext.Provider>
    );
}

export default Wrapper;
